module.exports = __webpack_public_path__ + "img/86d3f25.jpg";